// src/app/core/oauth-patch.ts
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

export function patchOAuthUserProfile(): () => void {
  return () => {
    const oauth = inject(OAuthService);

    // Override the method that would call /userinfo.
    oauth.loadUserProfile = () => {
      // Grab whatever claims came back in your ID token:
      const claims = (oauth.getIdentityClaims() as Record<string, unknown>) || {};
      // Assign them onto the 'userProfile' property that ABP reads:
      (oauth as any).userProfile = claims;
      // Resolve immediately—no HTTP:
      return Promise.resolve(claims);
    };
  };
}
